import { debounce } from "lodash"
import { useCallback } from "react"

export default function useDebounced(callback, delay) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedCallback = useCallback(debounce(callback, delay), [delay])
  return memoizedCallback
}
